import { useNavigate } from '@tanstack/react-router';
import { ReactNode, useEffect, useState } from 'react';

import { AuthContext } from './AuthContext';

import { getToken, isAuthenticated, logout } from '@/api/useAuth';
import { ROUTE_CONSTANTS } from '@/routes';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(isAuthenticated());
  const [token, setToken] = useState<string | null>(getToken());
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const authenticated = isAuthenticated();
      setIsLoggedIn(authenticated);
      setToken(getToken());
    };

    checkAuth();

    const handleStorageChange = () => {
      checkAuth();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setIsLoggedIn(false);
    setToken(null);
    void navigate({ to: ROUTE_CONSTANTS.LOGIN_PATH });
  };

  const value = {
    isLoggedIn,
    token,
    logout: handleLogout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
